// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelForm-Card_cls1__aKMuW","cls2":"PaymentChannelForm-Card_cls2__pBQa8 PaymentChannelForm-Card_cls1__aKMuW"};